import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-direction3",
  "use": "icon-direction3-usage",
  "viewBox": "0 0 1638 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1638 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-direction3\"><path fill=\"#333333\" d=\"M979.637895 404.210526l-253.541053 210.021053L747.789474 640l303.157894-253.338947L747.789474 134.736842l-21.726316 25.734737L979.671579 370.526316H242.526316v33.68421h737.111579z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol